(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sean-news"]) return;
  try {
    
function initNews(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-story]')];
  const search=root.querySelector('#news-search'),topic=root.querySelector('#news-topic'),year=root.querySelector('#news-year');
  const normalize=s=>s.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'');
  const years=[...new Set(cards.map(c=>c.dataset.year))].sort().reverse();
  years.forEach(y=>{const o=document.createElement('option');o.value=y;o.textContent=y;year.append(o);});
  [...topic.options].forEach(o=>{if(o.value&&!cards.some(c=>c.dataset.topic===o.value))o.remove();});
  function filter(){const terms=normalize(search.value).trim().split(/\s+/).filter(Boolean);let n=0;cards.forEach(c=>{const match=(!topic.value||c.dataset.topic===topic.value)&&(!year.value||c.dataset.year===year.value)&&terms.every(t=>normalize(c.dataset.search).split(/[^a-z0-9]+/).some(w=>w===t||(t.length>2&&w.startsWith(t))));c.hidden=!match;if(match)n++;});root.querySelector('[data-status]').textContent=root.dataset.results.replace('{count}',n).replace('{total}',cards.length);root.querySelector('[data-empty]').hidden=n!==0;}
  search.addEventListener('input',filter);topic.addEventListener('change',filter);year.addEventListener('change',filter);
  root.querySelector('[data-clear]').addEventListener('click',()=>{search.value='';topic.value='';year.value='';filter();search.focus();});
  root.querySelector('[data-tools]').hidden=false;
}
document.querySelectorAll('[data-news]').forEach(initNews);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-news]').forEach(initNews));

  } catch(e) { console.error(e); }
})();
})();
